import { Form, Input } from 'antd';

export default function InputNormal(props: any) {
    const { label, name, type } = props;
    return (
        <Form.Item label={label} name={name} {...props}>
            <Input type={type} {...props} />
        </Form.Item>
    )
}
